/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';
import { parseDate, convertFullAddress } from '@global/helpers';
import TitleSubSection from '@components/global/TitleSubSection';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const defaultPhoto = require('@/assets/img/default/user-default.png');

// eslint-disable-next-line react/prop-types
const TargetActivity = ({ detailCustomer = {}, detailActivity = {} }) => {
  return (
    <>
      {detailCustomer && Object.keys(detailCustomer).length ? (
        <>
          <TitleSubSection title="CUSTOMER INFO"></TitleSubSection>
          <View style={styles.listSection}>
            <ItemDetail
              name="Alias / Name"
              value={detailCustomer.name ? detailCustomer.name : '-'}
            />
            <ItemDetail
              name="Address"
              value={convertFullAddress(detailActivity?.customer?.address)}
            />
            <ItemDetail
              name="Phone"
              value={detailCustomer.phone ? detailCustomer.phone : '-'}
            />
            <ItemDetail
              name="Mobile"
              value={detailCustomer.mobile ? detailCustomer.mobile : '-'}
            />
          </View>
        </>
      ) : (
        false
      )}
      <TitleSubSection title="ACTIVITY DETAIL"></TitleSubSection>
      <View style={styles.listSection}>
        <ItemDetail
          name="Visit Date"
          value={`${
            detailActivity.visited_at
              ? parseDate(detailActivity.visited_at, 'd MMM yyyy')
              : '-'
          } ${
            detailActivity?.start_time && detailActivity?.end_time
              ? `${detailActivity?.start_time} - ${detailActivity?.end_time}`
              : ``
          }`}
        />
        <ItemDetail
          name="Notes"
          value={
            detailActivity && detailActivity.notes ? detailActivity.notes : '-'
          }
        />
        <ItemDetail
          centered
          name="Submitted by"
          value={
            detailActivity &&
            detailActivity.created_by &&
            detailActivity.created_by.name ? (
              // eslint-disable-next-line react-native/no-inline-styles
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View
                  style={{
                    width: 20,
                    height: 20,
                    overflow: 'hidden',
                    borderRadius: 20,
                    marginRight: 8,
                  }}>
                  <Image
                    source={defaultPhoto}
                    style={{ width: 20, height: 20 }}
                    width={20}
                    height={20}
                    defaultSource={defaultPhoto}
                  />
                </View>
                <SociollaText style={{ fontSize: 12 }}>
                  {detailActivity.created_by.name}
                </SociollaText>
              </View>
            ) : (
              '-'
            )
          }
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  listSection: {
    paddingTop: 10,
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
});

export default TargetActivity;
